/**
 * Selos da ficha (SRP, Lei SE 8.747/2020) e nomes do resultado geral (D92–D93). O resultado por item fica na aba Disputa (D98).
 */
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";

/* ------------------------------------ Selos da ficha ------------------------------------ */

export interface DadosSelos {
  srp: boolean;
  esfera: string | null;
  uf_destino: string | null;
  margem_preferencia: boolean;
}

/** Selos com a explicação de cada regra (texto da lei no tooltip). */
export function SelosLicitacao({ licitacao }: { licitacao: DadosSelos }) {
  const estadualSe = licitacao.esfera === "E" && licitacao.uf_destino === "SE";
  return (
    <>
      {licitacao.srp && (
        <Tooltip title="Sistema de registro de preços: o órgão registra o preço em ata para contratações futuras (Lei 14.133/2021, art. 6º, XLV). O preço registrado obriga o fornecedor a fornecer nas condições da ata, mas não obriga o órgão a contratar (art. 83).">
          <Chip size="small" variant="outlined" label="Registro de preços" />
        </Tooltip>
      )}
      {estadualSe && (
        <Tooltip
          title={
            <Box>
              Órgão estadual de Sergipe: vale a Lei SE 8.747/2020 para ME/EPP sediadas em SE (a Sobral Nunes é ME em Aracaju).
              <br />• Itens de até R$ 120 mil: licitação exclusiva para ME/EPP locais ou regionais (art. 2º, redação da Lei SE 9.493/2024).
              <br />• Acima disso: cota reservada de até 25% do objeto (art. 2º, § 3º).
              <br />• Ampla participação: margem de preferência de até 10% sobre a melhor proposta válida (art. 3º).
            </Box>
          }
        >
          <Chip size="small" color="secondary" label="Preferência ME/EPP de SE (Lei SE 8.747/2020)" />
        </Tooltip>
      )}
      {licitacao.margem_preferencia && !estadualSe && (
        <Tooltip title="O edital prevê margem de preferência (conferir os termos no edital).">
          <Chip size="small" variant="outlined" color="secondary" label="Margem de preferência" />
        </Tooltip>
      )}
    </>
  );
}

/* ------------------------------------ Resultado ------------------------------------ */

export const NOME_RESULTADO: Record<string, string> = {
  ganha: "Ganha",
  ganha_em_parte: "Ganha em parte",
  perdida: "Perdida",
  fracassada: "Fracassada",
  deserta: "Deserta",
  pendente: "Resultado incompleto",
};
